import React from "react";
import { HeadingProps } from "@/app/utilities/interfaces";

const sizes = {
  h1: "font-roboto text-[24px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
  h2: "font-roboto text-[20px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
  h3: "font-roboto text-[20px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
  h4: "font-roboto text-[20px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
  h5: "font-roboto text-[20px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
  h6: "font-roboto text-[20px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
  p: "font-roboto text-[20px] leading-[28px] tracking-[0px] text-[#101828] md:text-[23px]",
};

const Heading: React.FC<HeadingProps> = ({
  tag = "h2",
  children,
  className,
  size = "h2",
  uppercase = true,
  color = "",
  dataTestId="heading-automation"
}) => {
  const TagName = tag;

  return (
    <TagName
      className={`${sizes[size]} ${uppercase ? "" : ""} ${color ?? ""} ${className ?? ""}`}
      data-testid={dataTestId}
    >
      {children}
    </TagName>
  );
};

export default Heading;